import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container } from "@mui/material";
import { useState } from "react";
import { useUser } from "../contexts/UserContext";
import {getMyProfile, MyProfile} from "../services/UsersService";
import TopBar from "../components/TopBar";

interface UserProfile {
  fullName: string;
  userName: string;
  email: string;
  password: string;
  address: string;
  phone: string;
  image: string;
}

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const noNavRoutes = ["/login", "/signup", "/forgot-password"];
  const showNavBar = !noNavRoutes.includes(location.pathname);
  const [loading, setLoading] = useState(true);
  // use global user - local profile is kept for backwards compatibility
  const { user } = useUser();
  const [profile, setProfile] = useState<MyProfile | undefined>(undefined);

useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await getMyProfile();
      console.log("Profile data:", res); // Debug log to see what data we're getting
      setProfile(res);   
    } catch (err) {
      console.error("Failed to load profile", err);
    } finally {
      setLoading(false);
    }
  };

  fetchProfile();
}, []);

// Listen to user context changes and update profile accordingly
useEffect(() => {
  if (user) {
    setProfile((prev) => ({
      ...prev,
      ...user,
      fullName: user.fullName || prev?.fullName || "",
      email: user.email || prev?.email || "",
      phone: user.phone || prev?.phone || "",
      country: user.country || prev?.country || "",
      banner: user.banner !== undefined ? user.banner : (prev?.banner || null),
    } as MyProfile));
  }
}, [user]);

  return (
    <>
      {showNavBar && (
        <TopBar
          profile={profile}
          position="static"
          sx={{ mb: { xs: 1, sm: 2 } }}
          toolbarSx={{ minHeight: { xs: 48, sm: 64 } }}
        />
      )}
      <Container
        sx={{
          padding: 0,
          margin: 0,
          maxWidth: "100vw !important",
          minWidth: 0,
          width: "100vw",
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
        disableGutters
      >
        {children}
      </Container>
      <style>{`
        @media (max-width: 600px) {
          body, #root {
            width: 100vw;
            overflow-x: hidden;
          }
        }
      `}</style>
    </>
  );
};

export default MainLayout;
